import Vue from 'vue'

export default {

  SET_DRAG_ITEM(state, item) {
    state.drag_item = item
  },

  SET_DRAG_ITEM_TYPE(state, type) {
    state.drag_item_type = type
  },

  SET_DRAG_TARGET_DATE(state, date) {
    state.drag_target_date = date
  },

  SET_DRAG_ACTIVE(state, val) {
    state.drag_active = val
  },

  SET_DRAG_TIME_ACTIVE(state, val) {
    state.drag_time_active = val

    if (val === false) {
      state.drag_item = null
      state.drag_time_selection = null
      state.drag_time_offset = 0
    }
  },

  SET_DRAG_TIME_SELECTION(state, val) {
    state.drag_time_selection = val
  },

  SET_DRAG_TIME_OFFSET(state, val) {
    state.drag_time_offset = val
  },

  SET_DRAG_TARGET_INDEX(state, val) {
    state.drag_target_index = val
  },

  SELECT_DATE(state, value) {
    state.view_selected = value;
  },

  SET_VIEW_DATE(state, value) {
    state.view_from = value;
    state.view_to = null;
  },

  SET_VIEW_RANGE(state, { from, to }) {
    state.view_from = from;
    state.view_to = to;
  },

  TOGGLE_SHOW_REDUCED_DAYPLAN(state) {
    state.show_reduced_dayplan = !state.show_reduced_dayplan;
  },

  // SET_DRAG_TIME_ACTIVE(state, value) {
  //   state.drag_time_active = value;
  // },

  SET_COLUMN_LAYOUT(state, value) {
    state.column_layout = value;
  },

  SET_SHOW_NOTHING_PLANNED(state, value) {
    state.show_nothing_planned = value;
  },

  SET_COMMITMENT_CACHE(state, { data, hash }) {
    // Vue.set(state.commitment_data_cache, 'XXX', data)
    Vue.set(state, 'commitment_data_cache', data)
    state.commitment_data_hash = hash;
  },

  SHOW_BACKLOG(state, sessionId ) {
    Vue.set(state.show_backlog_list, sessionId, true);
  },

  HIDE_BACKLOG(state, sessionId ) {
    Vue.set(state.show_backlog_list, sessionId, false);
  },

  HIDE_BACKLOG_ALL(state) {
    Object
      .keys(state.show_backlog_list)
      .forEach(k => Vue.set(state.show_backlog_list, k, false))
  },
};
